const withdrawStatus = {
  APPLY: 0,
  CANCEL: 1,
  APPROVE: 2,
  REJECT: 3,
};

export default withdrawStatus;
